import { ref } from 'vue';

import { CatalogsApi } from 'SharedDir/backend/api';
import useCustomLoading from 'SharedDir/common/composables/useCustomLoading';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import { HandsontableCellType } from 'SharedDir/constants/field-types';
import { Catalogs } from 'SharedDir/declarations/catalogs';
import TableColumn from 'SharedDir/service/fields/_Table/table-column';

const catalogsOptions: Record<string, Catalogs.CatalogsValueFull> = ref({});

export default function useTableCatalogs() {
  const { loading: catalogsLoading, requestOptions } = useCustomLoading();

  function makeMissedCatalogsRequests(
    catalogColumns: TableColumn[]
  ): (undefined | Promise<Catalogs.CatalogsFull>)[] {
    return catalogColumns
      .map((column) => {
        if (catalogsOptions.value[column.catalogSlug]) {
          return undefined;
        }

        return CatalogsApi.ValuesApi(column.catalogSlug).getAllValues();
      })
      .filter((catalogRequest) => typeof catalogRequest !== 'undefined');
  }

  function saveFetchedCatalogs(results) {
    results.forEach((catalog) => {
      catalogsOptions.value[catalog.slug] = catalog.values;
    });
  }

  function loadCatalogs(columns: TableColumn[]) {
    const catalogColumns = columns.filter(
      (column) => column.type === HandsontableCellType.catalog && column.catalogSlug
    );

    if (catalogColumns.length === 0) {
      return undefined;
    }

    return new Promise((resolve, reject) => {
      const requests = makeMissedCatalogsRequests(catalogColumns);
      makeRequest(() => Promise.all(requests).then(saveFetchedCatalogs), requestOptions)
        .then(resolve)
        .catch(reject);
    });
  }

  return {
    catalogsLoading,
    catalogsOptions,
    loadCatalogs,
  };
}
